import { axios } from "../../lib/axios";

export const DeleteInstructor = (instructorId: string) => {
    return axios.delete(`/instructor/${instructorId}`)
        .then(response => response.data);
};